import { Box, Typography, Divider } from "@mui/material";

const VendorProcurement = () => {
  return (
    <Box>
      <Box p={2}>
        <Typography variant="h4" m={2}>
          Vendor Procurement
        </Typography>
      </Box>
      <Divider />
    </Box>
  );
};

export default VendorProcurement;
